import React, { useEffect, useRef } from 'react';
import '../Styles/Switch.css';

function Switch({
  id,
  checked,
  onChange,
  label,
  disabled,
  indeterminate,
  hideLabel = false,
  ariaDescribedBy,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !!indeterminate;
  }, [indeterminate]);

  return (
    <label className="switch" htmlFor={id} aria-label={label}>
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="switch__input"
        role="switch"
        aria-checked={indeterminate ? 'mixed' : (checked ? 'true' : 'false')}
        aria-describedby={ariaDescribedBy}
        checked={!!checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="switch__track">
        <span className="switch__thumb" />
      </span>
      {label && !hideLabel && <span className="switch__label">{label}</span>}
    </label>
  );
}

export default Switch;
